import React, { useState, useEffect } from "react";
import {
  Card,
  Form,
  Input,
  Button,
  message,
  Modal,
  Upload,
  DatePicker,
  Select,
  Table,
  Tag,
  Space,
  InputNumber,
  Divider,
  Row,
  Col,
  Checkbox,
  Typography,
  Descriptions,
  Avatar,
  Statistic,
  Empty,
} from "antd";
import { UploadOutlined, UserOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import { fetchTerms } from "../../store/termSlice";
import {
  fetchPaymentInformation,
  fetchStudentFeeStructure,
  createPaymentTransaction,
  fetchStudentTransactionDetail,
} from "../../store/createPaymentSlice.js";
import useTokenExpiryCheck from "../../utils/UseTokenExpiryCheck";

const { Option } = Select;
const { Title } = Typography;

//studnet_feeStructures
const MakePayment = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { terms } = useSelector((state) => state.terms);
  const studentData = location.state?.studentData;
  const selectedBatchId = studentData?.batchId;
  const { student_feeStructures } = useSelector((state) => state.payments);
  const { transactionHistory } = useSelector((state) => state.payments);

  const [form] = Form.useForm();
  const [selectedStudentId, setSelectedStudentId] = useState(null);
  const [selectedTermID, setSelectedTermID] = useState(null);
  const [selectedTermName, setSelectedTermName] = useState(null);
  const [selectedFees, setSelectedFees] = useState([]);
  const [minimumAmountForPayment, setMinimumAmountForPayment] = useState(0);
  const [maximumAmountForPayment, setMaximumAmountForPayment] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  //
  //Not used so far
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [previewUrl, setPreviewUrl] = useState(null);
  const [base64Strings, setBase64Strings] = useState(null);

  useTokenExpiryCheck();

  //UseEffect 1: fetch terms for subsequent use
  useEffect(() => {
    dispatch(fetchTerms());
  }, [dispatch]);

  //UseEffect 2: Set selectedStudent ID  and term ID from the studentData which is a paramter passed through local state
  useEffect(() => {
    if (!studentData) {
      message.error("No student data provided");
      return;
    }
    setSelectedStudentId(studentData.studentId);
    setSelectedTermID(studentData.termID);
    if (terms) {
      const name =
        terms.find((t) => t.termId === studentData.termID)?.name || "";
      const accYear =
        terms.find((t) => t.termId === studentData.termID)?.academicYear || "";
      const termName = `${name} - ${accYear}`;
      console.log("name", name);
      console.log("accYear", accYear);
      console.log("termName", termName);
      setSelectedTermName(termName);
    }
  }, [studentData, terms]);

  //UseEffect 3: fetch students fee structure which will set student_feeStructures, initialize the fee structure detail table, calls handleFeeSelect function, set setSelectedfee
  useEffect(() => {
    if (selectedStudentId && selectedTermID) {
      dispatch(
        fetchStudentFeeStructure({
          studentId: selectedStudentId,
          termId: selectedTermID,
        })
      );
    }
  }, [dispatch, selectedTermID, selectedStudentId]);

  //UseEffect 4: fetch students payment information for the specified Termid and student id
  //  which will set student_feeStructures, initialize the fee
  useEffect(() => {
    if (selectedStudentId && selectedTermID) {
      console.log("selectedStudentId", selectedStudentId);
      console.log("selectedTerm", selectedTermID);
      console.log("batchId", selectedBatchId);
      dispatch(
        fetchPaymentInformation({
          batchId: selectedBatchId,
          termId: selectedTermID,
        })
      );
      dispatch(
        fetchStudentTransactionDetail({
          studentId: selectedStudentId,
          termId: selectedTermID,
        })
      );

      //
    }
  }, [dispatch, selectedTermID, selectedBatchId, selectedStudentId]);

  //UseEffect 5: calculate the total amount of the student fee structure
  useEffect(() => {
    if (student_feeStructures) {
      const totalAmount = student_feeStructures.reduce(
        (sum, fee) => sum + (fee.feeAmount || 0),
        0
      );
      setTotalAmount(totalAmount);
    }
  }, [student_feeStructures]);

  //Not used so far

  useEffect(() => {
    const totalSelectedAmount = selectedFees.reduce(
      (sum, fee) => sum + (fee.feeAmount || 0),
      0
    );
    setMaximumAmountForPayment(totalSelectedAmount);

    const minimumPaymentRequired = selectedFees
      .slice(0, -1) // This returns a new array that contains all elements except the last one
      .reduce((sum, fee) => sum + (fee.feeAmount || 0), 0);
    setMinimumAmountForPayment(minimumPaymentRequired);
  }, [selectedFees]);

  //Function 1:
  const handleFeeSelect = (feeId, checked) => {
    if (checked) {
      setSelectedFees([...selectedFees, feeId]);
    } else {
      setSelectedFees(selectedFees.filter((id) => id !== feeId));
    }
  };
  const handleImageClick = (base64String) => {
    setModalImage(base64String);
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };
  const handleSubmit = async (values) => {
    try {
      setLoading(true);

      let processedAmountSoFar = 0;
      let successCount = 0;

      // Function to create payload
      const createPayload = (fee, paidAmount) => ({
        studentFeeStructureID: fee.studentFeeStructureID,
        paidAmount: paidAmount,
        reference: values.reference,
        paymentDocument: base64Strings,
        paymentDate: values.paymentDate
          ? values.paymentDate.toISOString()
          : new Date().toISOString(),
        remark: values.remark,
      });

      // Process each fee and dispatch payments
      await Promise.all(
        selectedFees.map(async (fee) => {
          let amountFromThisFee = fee.feeAmount;

          if (processedAmountSoFar + amountFromThisFee > values.paidAmount) {
            amountFromThisFee = values.paidAmount - processedAmountSoFar;
          }

          // Only process if there is an amount to process
          if (amountFromThisFee > 0) {
            const payload = createPayload(fee, amountFromThisFee);
            await dispatch(createPaymentTransaction(payload)); // Assuming this returns a promise
            processedAmountSoFar += amountFromThisFee;
            successCount++;
            console.log("Submitting payment:", payload);
          }
        })
      );

      // Display a message after all payments are processed
      if (successCount > 0) {
        message.success(`${successCount} payment(s) updated successfully`);
      }

      form.resetFields();
    } catch (error) {
      console.error("Error updating payment:", error);
      message.error(error.message || "Failed to update payment");
    } finally {
      setLoading(false);
    }
  };

  const onFinish = (values) => {
    handleSubmit(values);
  };

  const handleFileChange = (file) => {
    setSelectedFile(file.name);

    // Show preview if it's an image
    if (file && file.type.startsWith("image/")) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const base64String = e.target.result.split(",")[1]; // Remove data:*/*;base64, part
        setBase64Strings(base64String);
        setPreviewUrl(e.target.result); // Optional: still show preview
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };
  const placeholderText = `Please provide an amount between ${minimumAmountForPayment} and ${maximumAmountForPayment}`;
  return (
    <div style={{ padding: "24px", background: "#f0f2f5", minHeight: "100vh" }}>
      <Space direction="vertical" size="large" style={{ width: "100%" }}>
        <Card>
          <Row gutter={[24, 24]} align="middle">
            <Col span={2}>
              <Avatar size={64} icon={<UserOutlined />} />
            </Col>
            <Col span={22}>
              <Descriptions title="Student Information" bordered>
                <Descriptions.Item label="Name">
                  {studentData?.fullName}
                </Descriptions.Item>
                <Descriptions.Item label="ID">
                  {studentData?.studentIdno}
                </Descriptions.Item>
                <Descriptions.Item label="Section">
                  {studentData?.sectionName}
                </Descriptions.Item>
                <Descriptions.Item label="Term">
                  <Select
                    placeholder="Select Term"
                    style={{ width: 200 }}
                    value={selectedTermID}
                    disabled={selectedTermID}
                  >
                    {terms.map((term) => (
                      <Option key={term.termId} value={term.termId}>
                        {term.name}-{term.academicYear}
                      </Option>
                    ))}
                  </Select>
                </Descriptions.Item>
              </Descriptions>
            </Col>
          </Row>
        </Card>

        <Card>
          <Row gutter={24}>
            <Col span={8}>
              <Statistic
                title="Total Payable Amount"
                value={studentData?.payableAmount || 0}
                prefix="$"
                valueStyle={{ color: "#1890ff" }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Paid Amount"
                value={studentData?.paidAmount || 0}
                prefix="$"
                valueStyle={{ color: "#52c41a" }}
              />
            </Col>
            <Col span={8}>
              <Statistic
                title="Unpaid Amount"
                value={studentData?.unpaidAmount || 0}
                prefix="$"
                valueStyle={{
                  color: studentData?.unpaidAmount > 0 ? "#ff4d4f" : "#52c41a",
                }}
              />
            </Col>
          </Row>
        </Card>

        {student_feeStructures && student_feeStructures.length > 0 ? (
          <Card
            title={`Fee Structure Details - ${selectedTermName}
              `}
          >
            <Table
              dataSource={student_feeStructures}
              pagination={false}
              rowKey="feeID"
              columns={[
                {
                  title: "Select",
                  dataIndex: "feeID",
                  render: (_, feeID) => (
                    <Checkbox
                      checked={selectedFees.includes(feeID)}
                      onChange={(e) => handleFeeSelect(feeID, e.target.checked)}
                      //                      disabled={paymentInfo.status === "FullyPaid"}
                    />
                  ),
                },
                {
                  title: "Fee Type",
                  dataIndex: "feeType",
                },
                {
                  title: "termName",
                  dataIndex: "termID",
                  render: (termID) => `${selectedTermName}`,
                },
                {
                  title: "Total Payable",
                  dataIndex: "feeAmount",
                  render: (feeAmount) => `$${(feeAmount || 0).toFixed(2)}`,
                },
                {
                  title: "Paid amount",
                  dataIndex: "paidAmount",
                  render: (paidAmount) => `$${(paidAmount || 0).toFixed(2)}`,
                },
                {
                  title: "Unpaid amount",
                  dataIndex: "unpaidAmount",
                  render: (feeAmount, paidAmount) =>
                    `$${(feeAmount - paidAmount || 0).toFixed(2)}`,
                },
                {
                  title: "category",
                  dataIndex: "category",
                },
                {
                  title: "Payment Period",
                  render: (_, record) => (
                    <>
                      {record.paymentStartDate
                        ? moment(record.paymentStartDate).format("DD/MM/YYYY")
                        : "N/A"}
                      -
                      {record.paymentEndDate
                        ? moment(record.paymentEndDate).format("DD/MM/YYYY")
                        : "N/A"}
                    </>
                  ),
                },
              ]}
            />
            <div style={{ marginTop: 16, textAlign: "right" }}>
              <Typography.Text strong>
                <Row justify="end" style={{ marginTop: 16 }}>
                  <Col>
                    <p>
                      <strong>Total Selected Amount:</strong> $
                      {maximumAmountForPayment.toFixed(2)}
                    </p>
                    <p>
                      <strong>Total Amount:</strong> ${totalAmount.toFixed(2)}
                    </p>
                  </Col>
                </Row>
              </Typography.Text>
            </div>
          </Card>
        ) : (
          <Card>
            <Empty
              description={
                selectedTermID
                  ? "No fee structures found for selected term"
                  : "Please select a term"
              }
            />
          </Card>
        )}

        <Card title="Payment Details">
          <Descriptions title="Payment Information" bordered>
            <Descriptions.Item label="Payment Status"></Descriptions.Item>
          </Descriptions>
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Row gutter={16}>
              <Col span={8}>
                <Form.Item
                  name="paidAmount"
                  label="Payment Amount"
                  rules={[
                    { required: true, message: "Please enter payment amount" },
                    {
                      validator: (_, value) => {
                        if (value < minimumAmountForPayment) {
                          return Promise.reject(
                            `Amount must be >= ${minimumAmountForPayment}`
                          );
                        }
                        if (value > maximumAmountForPayment) {
                          return Promise.reject(
                            `Amount must be <= ${maximumAmountForPayment}`
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <InputNumber
                    style={{ width: "100%" }}
                    precision={2}
                    placeholder={placeholderText}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="reference"
                  label="Reference"
                  rules={[
                    {
                      required: true,
                      message: "Please enter reference number",
                    },
                  ]}
                >
                  <Input placeholder="Enter reference number" />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  name="paymentDate"
                  label="Payment Date"
                  rules={[
                    { required: true, message: "Please select payment date" },
                  ]}
                >
                  <DatePicker style={{ width: "100%" }} />
                </Form.Item>
              </Col>
              <Col span={8}>
                <Form.Item
                  label="Reference Document"
                  name="referenceDcoument"
                  valuePropName="file" // optional, just clarifies intent
                  rules={[
                    {
                      required: true,
                      message: "Please enter reference document or attachment",
                    },
                  ]}
                >
                  <Upload
                    beforeUpload={() => false} // prevent auto upload
                    onChange={(e) =>
                      handleFileChange(e.file, "referenceDcoument")
                    }
                    accept=".pdf,.jpg,.jpeg,.png"
                    showUploadList={false} // optionally hide default upload list
                  >
                    <Button
                      icon={<UploadOutlined />}
                      className={"cursor-not-allowed"}
                    >
                      Upload File
                    </Button>
                  </Upload>

                  {/* Show file name if uploaded */}
                  {selectedFile && <p className="mt-2">{selectedFile}</p>}

                  {/* Show image preview if available */}
                  {previewUrl && (
                    <img
                      src={previewUrl}
                      alt="reference dcoument"
                      style={{ width: "200px", height: "auto" }}
                      className="mt-4 rounded shadow"
                    />
                  )}
                </Form.Item>
              </Col>
              <Col span={16}>
                <Form.Item name="remark" label="Remark">
                  <Input.TextArea rows={2} placeholder="Enter remarks" />
                </Form.Item>
              </Col>
              <Col span={24}>
                <Form.Item>
                  <Button
                    type="primary"
                    htmlType="submit"
                    loading={loading}
                    disabled={!studentData || studentData.unpaidAmount <= 0}
                    block
                  >
                    Submit Payment
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Card>

        {/* Transaction History Section */}
        <Card
          title={<Title level={4}>Transactions Detail</Title>}
          className="mt-4"
          style={{ marginTop: "24px" }}
        >
          <Table
            dataSource={transactionHistory}
            rowKey="id"
            pagination={{ pageSize: 5 }}
            loading={loading}
          >
            <Table.Column
              title="Student ID"
              dataIndex="studentIdno"
              key="studentIdno"
            />
            <Table.Column
              title="Date"
              dataIndex="paymentDate"
              key="paymentDate"
              render={(date) =>
                date ? moment(date).format("DD/MM/YYYY") : "N/A"
              }
            />
            <Table.Column
              title="Term"
              dataIndex={["term", "termName"]}
              key="term"
              render={() => selectedTermName}
            />
            <Table.Column
              title="Fee Type"
              key="feeType"
              render={(_, record) => {
                const matchedStructure = student_feeStructures.find(
                  (item) =>
                    item.studentFeeStructureID === record.studentFeeStructureID
                );
                return matchedStructure?.feeType || "N/A";
              }}
            />
            <Table.Column
              title="Amount"
              dataIndex="paidAmount"
              key="paidAmount"
              render={(paidAmount) => (
                <span style={{ color: "#389e0d" }}>
                  ${(Number(paidAmount) || 0).toFixed(2)}
                </span>
              )}
            />
            <Table.Column
              title="reference"
              dataIndex="reference"
              key="reference"
              render={(reference) => reference || "N/A"}
            />
            <Table.Column
              title="Status"
              dataIndex="status"
              key="status"
              render={(status) => {
                if (status === 0) return "Pending";
                if (status === 1) return "Approved";
                if (status === 2) return "Rejected";
                return "N/A"; // fallback for unexpected values
              }}
            />
            <Table.Column
              title="Payment Document"
              dataIndex="paymentDocument"
              key="paymentDocument"
              render={(base64String) =>
                base64String ? (
                  <img
                    src={`data:image/png;base64,${base64String}`}
                    alt="payment"
                    style={{
                      width: 50,
                      height: 50,
                      objectFit: "cover",
                      cursor: "pointer",
                    }}
                    onClick={() => handleImageClick(base64String)}
                  />
                ) : (
                  "N/A"
                )
              }
            />
            <Table.Column
              title="remark"
              dataIndex="remark"
              key="remark"
              render={(remark) => remark || "N/A"}
            />
          </Table>
        </Card>
      </Space>
      <Modal
        open={isModalOpen}
        footer={null}
        onCancel={handleModalClose}
        centered
      >
        {modalImage && (
          <img
            src={`data:image/png;base64,${modalImage}`}
            alt="Full Size Payment Document"
            style={{ width: "100%", height: "auto" }}
          />
        )}
      </Modal>
    </div>
  );
};

export default MakePayment;
